import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_104phd1wp3: FaireBrandEntity = {
  token: "b_104phd1wp3",
  type: "brand",
  name: "Simple Whimsy",
  avatarUrl:
    "https://cdn.faire.com/fastly/1d90e0dce3d0b6b3e789dd7c262ae64d5e62ff395ae9e6d4b1c6c98e64958978.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2644be3db0c9e9fbe64663b644c349132bbfbcbd68df6b08a09303fc3aaf2e68.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1d90e0dce3d0b6b3e789dd7c262ae64d5e62ff395ae9e6d4b1c6c98e64958978.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2644be3db0c9e9fbe64663b644c349132bbfbcbd68df6b08a09303fc3aaf2e68.png",
  location: "Mississauga, ON, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 61,
  isTopShop: true,
  isInsider: false,
  description:
    "Simple Whimsy is a line of hand-illustrated greeting cards and stickers designed by Sam and printed in Canada. Based in Mississauga, Ontario, our collections bring together bright happy design and cozy illustrations (all drawn by hand, never ai!)\n\nWe’re big into keeping the whimsy alive and loving hard on all the silly, quirky things that make life fun!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:42.942Z",
    importedBy: "entity-db-cli",
  },
};
